import _ from 'lodash';
import { del, get, patch, post } from './agent';

const sage = {
  workspace:
    (workspacesUrl) =>
    (id = '') => {
      const url = _([workspacesUrl, 'sage', id]).compact().join('/');

      return {
        inspect: (body) => post(_([workspacesUrl, 'sage', 'inspect']).compact().join('/'), body),
        connect: (body) => post(_([workspacesUrl, 'sage', 'connect']).compact().join('/'), body),
        reauthorize: () => post(url.concat('/reauthorize')),
        getStatus: () => get(url.concat('/status')),
        getCompany: () => get(url.concat('/company')),
        getIntegration: () => get(url.concat('/integration')),
        remove: () => del(url.concat('/integration')),
        getConfiguration: () => get(url.concat('/configuration')),
        getConfigurationStatus: () => get(url.concat('/configuration/status')),
        updateConfiguration: (body) => patch(url.concat('/configuration'), body),
        setupConfiguration: () => post(url.concat('/setup/configuration')),

        getCustomers: () => get(url.concat('/customers')),
        getClientMappings: () => get(url.concat('/mapping/clients')),
        updateClientMappings: (body) => post(url.concat('/mapping/clients'), body),
        setupClients: () => post(url.concat('/setup/clients')),

        getItems: () => get(url.concat('/items')),
        getInvoiceItemMappings: () => get(url.concat('/mapping/invoice-items')),
        updateInvoiceItemMappings: (body) => post(url.concat('/mapping/invoice-items'), body),
        setupInvoiceItems: () => post(url.concat('/setup/invoice-items')),

        getTaxDetails: () => get(url.concat('/tax-details')),
        getTaxRateMappings: () => get(url.concat('/mapping/tax-rates')),
        updateTaxRateMappings: (body) => post(url.concat('/mapping/tax-rates'), body),
        setupTaxRates: () => post(url.concat('/setup/tax-rates')),

        getVendors: () => get(url.concat('/vendors')),
        getMemberMappings: () => get(url.concat('/mapping/members')),
        updateMemberMappings: (body) => post(url.concat('/mapping/members'), body),
        setupMembers: () => post(url.concat('/setup/members')),

        getDepartments: () => get(url.concat('/departments')),
        getOrderEntryItems: () => get(url.concat('/order-entry/items')),
        getPurchasingItems: () => get(url.concat('/purchasing/items')),
        getExpenseAccounts: () => get(url.concat('/expense-accounts')),
        getExpenseCategoryMappings: () => get(url.concat('/mapping/expense-categories')),
        updateExpenseCategoryMappings: (body) => post(url.concat('/mapping/expense-categories'), body),
        setupExpenseCategories: () => post(url.concat('/setup/expense-categories')),

        getDepositAccountOptions: () => get(url.concat('/deposit-account-options')),
        getDepositAccountMappings: () => get(url.concat('/mapping/deposit-accounts')),
        updateDepositAccountMappings: (body) => post(url.concat('/mapping/deposit-accounts'), body),
        setupDepositAccounts: () => post(url.concat('/setup/deposit-accounts')),

        getPaymentMethodValues: () => get(url.concat('/payment-method-values')),
        getPaymentMethodMappings: () => get(url.concat('/mapping/payment-methods')),
        updatePaymentMethodMappings: (body) => post(url.concat('/mapping/payment-methods'), body),
        setupPaymentMethods: () => post(url.concat('/setup/payment-methods')),

        getWebhookSetup: () => get(url.concat('/webhook-setup')),

        getSyncs: () => get(url.concat('/expenses/syncs')),
        getSyncLog: (id) => get(url.concat('/expenses/syncs/', id, '/log')),
        manualSync: () => post(url.concat('/expenses/manual-sync')),
      };
    },
};

export default sage;
